<template lang="pug">
  .modal-card
    .modal-card-head
      header {{ title }}
    .modal-card-body
      b-field(label="カテゴリ名（表示用）" label-for="categoryName")
        b-input#categoryName(
          v-model="category.name"
          type="text"
          required size="is-medium"
          maxlength="20"
          @input="validateCategory")
      b-field(label-for="value")
        template(v-slot:label)
          | カテゴリ名（URL用）
          button.ml-3.ui-tooltip(type="button" @click="value.isDescriptionOpen = !value.isDescriptionOpen")
            b-icon.is-opacity(icon="question-circle" size="is-small")
        p.mb-5.is-size-5.has-text-left(v-if="value.isDescriptionOpen")
          | URLの一部として使われる名前です。<br>
          | 【半角小文字の英数字】【-（ハイフン）】【_（アンダースコア）】を利用してください。
        .categoryModal_value
          p.categoryModal_value_host._smalltext
            | {{ publicHost }}/?category=
          b-input#value(
            v-model="value.name"
            type="text"
            size="is-medium"
            required
            autocomplete="off"
            maxlength=50
            @input="validateValue")
        p.is-size-5.has-text-danger.has-text-weight-bold(v-if="value.status === 'isError'")
          | 空白・以下の文字は、URLに使用できません。<br>
          | ^ ! # $ & ' " ( ) * + , : ; = ? @ / [ ] < > % . ~
      b-field(label="親カテゴリ" label-for="parentCategoryName")
        b-select#parentCategoryName(
          v-model="parentCategory.name"
          size="is-medium")
          option(v-for="category in parentCategoryList" :value="category.screen_name" :key="category.id") {{ category.screen_name }}
      template
        label.label.mt-6 ラベルカラー
        b-dropdown.categoryModal_color(
          v-model="labelColor"
          append-to-body
          aria-role="list")
          template(slot="trigger")
            b-button(
              :label="labelColor.name"
              size="is-medium"
              icon-right="angle-down"
              :style="{ color: labelColor.text, 'background-color': labelColor.background }")
          b-dropdown-item.categoryModal_color_item(
            v-for="color in labelColorList"
            :key="color.id"
            :value="color"
            aria-role="listitem")
            .media
              .media-content(:style="{ color: color.text, 'background-color': color.background }")
                span {{ color.name }}
    .modal-card-foot
      b-button(
        v-if="modalType === 'add'"
        type="is-info"
        size="is-medium"
        :loading="form.isLoading"
        :disabled="!form.isCompleted"
        @click="addCategory()") 追加する
      b-button(
        v-else-if="modalType === 'edit'"
        type="is-info"
        size="is-medium"
        :loading="form.isLoading"
        :disabled="!form.isCompleted"
        @click="updateCategory()") 更新する
</template>

<script>
export default {
  name: 'CategoryModal',
  props: [
    'isModalActive',
    'modalType',
    'parentCategoryList',
    'categoryData',
  ],
  data: function(){
    return {
      title: '',

      form: {
        isCompleted: false,
        isLoading: false
      },
      category: {
        name: '',
        status: ''
      },
      value: {
        name: '',
        status: '',
        isDescriptionOpen: false
      },
      parentCategory: {
        name: null
      },
      labelColor: {
        id: null,
        name: null,
        text: null,
        background: null
      },
      labelColorList: [],
      errorMessage: {
        category: {
          notRegistered: 'このカテゴリ名は登録ができません。',
          alreadyRegistered: 'このカテゴリ名は既に登録されています。',
          characterLimit: 'カテゴリ名は20文字以内で入力してください。',
          empty: 'カテゴリ名（表示用）を入力してください。'
        },
        value: {
          alreadyRegistered: 'このカテゴリ名（URL用）は既に登録されています。',
          characterLimit: 'カテゴリ名（URL用）は50文字以内で入力してください。',
          empty: 'カテゴリ名（URL用）を入力してください。',
          invalid: 'カテゴリ名（URL用）に利用できない文字が入力されています。'
        },
        labelColor: {
          empty: 'ラベルカラーを選択してください。'
        },
        general: 'カテゴリの追加・更新に失敗しました。時間を空けて、もう一度お試しください。'
      },
      publicHost: process.env.VUE_APP_PUBLIC_HOST
    }
  },
  created() {
    this.getColorList()
  },
  mounted() {
    if( this.modalType === 'edit' ) {
      this.title = 'カテゴリの編集'

      this.category.name = this.categoryData.screen_name
      this.value.name = this.categoryData.value
      this.parentCategory.name = this.categoryData.parent_name
      this.labelColor = this.categoryData.color

      this.validateCategory()
      this.validateValue()
    } else if ( this.modalType === 'add' ) {
      this.title = '新規カテゴリの追加'

      this.parentCategory.name = this.parentCategoryList[0].screen_name
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    validateCategory() {
      this.category.status = ( this.category.name.length > 0 ) ? 'isCompleted' : 'isError'

      this.checkForm()
    },
    validateValue(){
      const unusableCharacters = this.value.name.match(/[\^!#$&'"()*+,:;=?@/[\]<>%.~\\\s]/)
      if( this.value.name.length > 0 ) {
        this.value.status = 'isCompleted'
        if ( unusableCharacters !== null ) this.value.status = 'isError'
      } else {
        this.value.status = ''
      }

      this.checkForm()
    },
    checkForm() {
      this.form.isCompleted = ( this.category.status === 'isCompleted' && this.value.status === 'isCompleted' ) ? true : false
    },
    async getColorList() {
      try {
        const res = await this.$axios.get(
            process.env.VUE_APP_API_ENDPOINT
            + process.env.VUE_APP_API_BASE_PATH
            + this.$constants.API_PATH.COLORS
        )
        const r = res.data
        if( r.status == 1 ){
          const data = r.data
          this.labelColorList = data

          if( this.modalType === 'add' ) {
            this.labelColor = this.labelColorList[0]
          }
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, 'カラーリストの取得に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
    async addCategory() {
      try {
        this.form.isLoading = true

        const data_obj = {
          input_name: this.category.name,
          value: this.value.name,
          category: {
            screen_name: this.parentCategory.name
          }
        }

        // サブカテゴリの場合、ラベルカラー追加
        if( this.parentCategory.name !== null ) data_obj.color_id = this.labelColor.id

        const data_json = JSON.stringify(data_obj)
        const config = { headers: {"Content-Type": "application/json"} }

        const res = await this.$axios.post(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.CATEGORIES,
          data_json,
          config
        )

        const r = res.data

        if( r.status == 1 ){
          if( this.parentCategory.name != null && r.first_adition ){
            this.$common.createSuccessMessage(
              'カテゴリ '+ this.category.name +' を追加しました。<br>これまでに投稿した ' + this.parentCategory.name + ' カテゴリに属する記事は「未分類」サブカテゴリに登録されます。',
              5000)
          } else {
            this.$common.createSuccessMessage('カテゴリ ' + this.category.name + ' を追加しました')
          }

          const _category_id = r.category_id
          const _sub_category_id = r.sub_category_id ? r.sub_category_id : ''

          this.$emit('setNewData', _category_id, _sub_category_id )

          this.closeModal()
        }else{
          let errorMessage = new Array()

          for(let i =0; i < r.errors.length; i++){ // updateCategoryと内容合わせる
            if(r.errors[i].status == 403) {
              this.$store.dispatch('promptToLogin')
              return
            } else if( r.errors[i].status == 56 ) {
              if( this.category.name === '未分類' ) {
                errorMessage.push(this.errorMessage.category.notRegistered)
              } else {
                errorMessage.push(this.errorMessage.category.alreadyRegistered)
              }
            } else if( r.errors[i].status == 57 ) {
              errorMessage.push(this.errorMessage.category.characterLimit)
            } else if( r.errors[i].status == 77 ) {
              errorMessage.push(this.errorMessage.category.empty)
            } else if( r.errors[i].status == 74 ) {
              errorMessage.push(this.errorMessage.value.alreadyRegistered)
            } else if( r.errors[i].status == 75 ) {
              errorMessage.push(this.errorMessage.value.characterLimit)
            } else if( r.errors[i].status == 76 ) {
              errorMessage.push(this.errorMessage.value.empty)
            } else if( r.errors[i].status == 78 ) {
              errorMessage.push(this.errorMessage.value.invalid)
            } else if( r.errors[i].status == 79 ) {
              errorMessage.push(this.errorMessage.labelColor.empty)
            } else {
              errorMessage.push(this.errorMessage.general)
            }
          }
          errorMessage = errorMessage.join('<br>')
          this.$common.createErrorMessage(r.errors, errorMessage)
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.form.isLoading = false
      }
    },
    async updateCategory() {
      try {
        this.form.isLoading = true

        const data_obj = {
          input_name: this.category.name,
          value: this.value.name,
          category: {
            screen_name: this.parentCategory.name
          }
        }

        // サブカテゴリの場合、ラベルカラー追加
        if( this.parentCategory.name !== null ) data_obj.color_id = this.labelColor.id

        const data_json = JSON.stringify(data_obj)
        const config = { headers: {"Content-Type": "application/json"} }

        const res = await this.$axios.put(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.CATEGORIES_.replace(':id', this.categoryData.id),
          data_json,
          config
        )

        const r = res.data

        if( r.status == 1 ){
          this.$common.createSuccessMessage('カテゴリ '+ this.category.name +' を更新しました')

          this.$emit('setNewData')

          this.closeModal()
        } else {
          let errorMessage = new Array()

          for(let i =0; i < r.errors.length; i++){ // addCategoryと内容合わせる
            if(r.errors[i].status == 403) {
              this.$store.dispatch('promptToLogin')
              return
            } else if( r.errors[i].status == 56 ) {
              if( this.category.name === '未分類' ) {
                errorMessage.push(this.errorMessage.category.notRegistered)
              } else {
                errorMessage.push(this.errorMessage.category.alreadyRegistered)
              }
            } else if( r.errors[i].status == 57 ) {
              errorMessage.push(this.errorMessage.category.characterLimit)
            } else if( r.errors[i].status == 77 ) {
              errorMessage.push(this.errorMessage.category.empty)
            } else if( r.errors[i].status == 74 ) {
              errorMessage.push(this.errorMessage.value.alreadyRegistered)
            } else if( r.errors[i].status == 75 ) {
              errorMessage.push(this.errorMessage.value.characterLimit)
            } else if( r.errors[i].status == 76 ) {
              errorMessage.push(this.errorMessage.value.empty)
            } else if( r.errors[i].status == 78 ) {
              errorMessage.push(this.errorMessage.value.invalid)
            } else if( r.errors[i].status == 79 ) {
              errorMessage.push(this.errorMessage.labelColor.empty)
            } else {
              errorMessage.push(this.errorMessage.general)
            }
          }
          errorMessage = errorMessage.join('<br>')
          this.$common.createErrorMessage(r.errors, errorMessage)
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.form.isLoading = false
      }
    }
  }
}
</script>
